import { useUncontrolledProp } from '@toolbox/hooks';
import { RadioGroupContextProvider } from './RadioGroupContext';

import type React from 'react';

export type RadioGroupProps<T> = {
  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: string;
  onChange?: (value: T) => void;
  value?: T;
  defaultValue?: T;
  children?: React.ReactNode;
};

export function RadioGroup<T>(props: RadioGroupProps<T>): JSX.Element {
  const { children, name, value: valueProp } = props;
  const [value, setValue] = useUncontrolledProp<T>(valueProp, props.defaultValue, props.onChange);

  return (
    <RadioGroupContextProvider<T> value={{ name, onChange: setValue, value }}>
      {children}
    </RadioGroupContextProvider>
  );
}
